(function fixCarouselSnap(){
  document.addEventListener('carousel:settle', function(e){
    var el = e.target;
    if (!el || el.tagName !== 'SCROLL-CAROUSEL') return;

    if (el.style.scrollSnapType === 'none') {
      el.style.removeProperty('scroll-snap-type');
    }

    if (e.detail && e.detail.index === 0 && el.classList.contains('peeking') && el.scrollLeft > 0) {
      el.scrollTo({ left: 0, behavior: 'auto' });
    }
  }, true);

  document.addEventListener('scrollend', function(e){
    var el = e.target;
    if (!el || el.tagName !== 'SCROLL-CAROUSEL') return;

    if (el.style.scrollSnapType === 'none') {
      el.style.removeProperty('scroll-snap-type');
    }
  }, true);
})();

(function initCardSwatchArrows(){
  function setup(wrap){
    var track = wrap.querySelector('[data-card-swatches-track]');
    var prev = wrap.querySelector('[data-swatches-prev]');
    var next = wrap.querySelector('[data-swatches-next]');
    if (!track || !prev || !next) return;
    if (wrap.__swatchArrowsBound) return;
    wrap.__swatchArrowsBound = true;

    function getUnit(){
      var swatch = track.querySelector('.color-swatch');
      if (!swatch) return 24;
      var gap = parseFloat(getComputedStyle(track).gap) || 5;
      return swatch.getBoundingClientRect().width + gap;
    }

    function clampWidth(){
      if (window.innerWidth < 700) {
        track.style.maxWidth = '';
        return;
      }
      var swatch = track.querySelector('.color-swatch');
      if (!swatch) return;

      var gap = parseFloat(getComputedStyle(track).gap) || 5;
      var swatchW = swatch.getBoundingClientRect().width;
      var unit = swatchW + gap;
      var total = track.querySelectorAll('.color-swatch').length;
      var contentWidth = total * unit - gap;

      track.style.maxWidth = '';
      var cardEl = wrap.closest('product-card') || wrap.closest('.product-card') || wrap.parentElement; var cardWidth = cardEl ? cardEl.clientWidth : wrap.parentElement.clientWidth;

      if (contentWidth <= cardWidth) return;

      var available = cardWidth - 32;
      var count = Math.floor((available + gap) / unit);
      if (count < 1) count = 1;
      track.style.maxWidth = (count * unit - gap) + 'px';
    }

    function updateArrows(){
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      var hasOverflow = track.scrollWidth > track.clientWidth + 1;

      prev.classList.toggle('is-shown', hasOverflow);
      next.classList.toggle('is-shown', hasOverflow);
      prev.classList.toggle('is-visible', hasOverflow && !atStart);
      next.classList.toggle('is-visible', hasOverflow && !atEnd);
    }

    prev.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var unit = getUnit();
      var target = Math.round(track.scrollLeft / unit - 1) * unit;
      track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    });

    next.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var unit = getUnit();
      var target = Math.round(track.scrollLeft / unit + 1) * unit;
      track.scrollTo({ left: Math.min(target, track.scrollWidth - track.clientWidth), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    clampWidth();
    updateArrows();

    var _resizeTimer;
    var card = wrap.closest('product-card') || wrap.closest('.product-card') || wrap.parentElement;
    new ResizeObserver(function(){
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(function(){
        clampWidth();
        updateArrows();
      }, 50);
    }).observe(card);
  }

  function init(){
    document.querySelectorAll('[data-card-swatches-wrap]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(function(){
    document.querySelectorAll('[data-card-swatches-wrap]:not([data-bound])').forEach(function(w){
      w.setAttribute('data-bound', '');
      setup(w);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
